import { render, staticRenderFns } from "./NotifDetail.vue?vue&type=template&id=3878b010&scoped=true"
import script from "./NotifDetail.vue?vue&type=script&lang=js"
export * from "./NotifDetail.vue?vue&type=script&lang=js"
import style0 from "./NotifDetail.vue?vue&type=style&index=0&id=3878b010&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3878b010",
  null
  
)

export default component.exports